import TypeLink from '../taxonomies/TypeLink';
import { globalStyles as styles } from '../../core/style/gstheme';
import { Typography } from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import { withStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';
import ClearIcon from '@material-ui/icons/Clear';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import IriDisplay from '../taxonomies/IriDisplay';
import { HAS_PROPERTY, HAS_PROPERTY_WITH_VALUE, DOES_NOT_HAVE_PROPERTY } from './constants';
import { sortResources, displayDate } from '../../core/utils/utils';
import { DATATYPES } from '../../core/utils/constants';

class SearchFilter extends Component {

  render() {

    const { defaultLang, graph, property, taxonomies, project, value, format, isExactMatch, classList,
      propertyName, classes, onRemoveFilter, filterType, range } = this.props;

    const sortedValues = format === "relation" ?
      value && value.length > 0 ?
        sortResources(value, this.props.graph, "prefLabel", defaultLang)
        :
        []
      :
      value ?
        [...value].sort()
        :
        [];

    return (
      <div
        data-test="search-filter"
        style={{
          textAlign: 'center',
          border: 'solid 1px #e5e5e5',
          backgroundColor: 'white',
          borderRadius: 4,
          marginBottom: 12,
          minHeight: 98,
          padding: '4px 6px'
        }}>
        <div style={{ display: 'flex' }}>
          <div>
            <Typography
              data-test="filter"
              variant="body2"
              style={{ marginTop: 4 }}>
              {propertyName}
            </Typography>
          </div>
          <div style={{ flex: 1, textAlign: 'right', marginLeft: 6 }}>
            <Tooltip title="Remove filter">
              <IconButton data-test="remove-filter"
                className={classes.smallIconButton}
                size="small"
                onClick={() => onRemoveFilter(property)}>
                <ClearIcon fontSize="small" />
              </IconButton>
            </Tooltip>
          </div>
        </div>
        <div style={{ marginBottom: 6 }}>
          <Typography data-test="filter-type" variant="caption" align="left">{
            filterType === HAS_PROPERTY ?
              "Has Property (With any Value)"
              :
              filterType === HAS_PROPERTY_WITH_VALUE ?
                format === "class" ?
                  sortedValues.length > 1 ?
                    "Has One or More Classes From"
                    :
                    "Has the Class"
                  :
                  sortedValues.length > 1 ?
                    "Has Property With One or More Values From"
                    :
                    "Has Property With Value"
                :
                filterType === DOES_NOT_HAVE_PROPERTY ?
                  format === "class" ?
                    "Does not Have Class"
                    :
                    "Does not Have Property"
                  :
                  format === "class" ?
                    "Does not Have One of the Classes"
                    :
                    "Does not Have Property With Specific Values"
          }
          </Typography>
        </div>
        {sortedValues.length > 0 &&
          <div data-test="sorted-values" style={{ display: 'flex', flexWrap: 'wrap' }}>
            {format === "relation" && sortedValues.map(v =>
              <IriDisplay
                key={v}
                id={v}
                components={taxonomies}
                projectIRI={project}
                handleNotAvailable={true}
                graph={graph}
                viewLang={defaultLang}
                defaultLang={defaultLang} />
            )}
            {format === "class" && sortedValues.map(v =>
              classList.some(c => c.value === v) ?
                <TypeLink
                  key={"rel-" + v}
                  id={v}
                  graph={classList.find(c => c.value === v).graph}
                  isReadOnly={true}
                  viewLang={defaultLang}
                  defaultLang={defaultLang} />
                :
                null
            )}
            {(format === "datatype" || format === "langString") &&
              <div style={{ display: 'flex', width: '100%' }}>
                <div style={{ flex: 1, textAlign: 'left' }}>
                  <Typography data-test="filter-text" variant="body2">
                    {
                      sortedValues.map(v => {
                        if (range === DATATYPES.DATE) {
                          return displayDate(v);
                        }
                        else if (range === DATATYPES.BOOLEAN) {
                          return v.toUpperCase();
                        }
                        return v;
                      }).join(' OR ')
                    }
                  </Typography>
                </div>
                {isExactMatch && range !== DATATYPES.DATE && range === DATATYPES.BOOLEAN &&
                  <div style={{ textAlign: 'right', marginLeft: 12, marginTop: 1 }}>
                    <Typography data-test="exact-matches" variant="caption">Exact Matches Only</Typography>
                  </div>
                }
              </div>
            }
          </div>
        }
      </div>
    );
  }

}

SearchFilter.propTypes = {
  classes: PropTypes.object,
  property: PropTypes.string.isRequired,
  format: PropTypes.string.isRequired,
  taxonomies: PropTypes.array,
  isExactMatch: PropTypes.bool,
  classList: PropTypes.array,
  propertyName: PropTypes.string.isRequired,
  filterType: PropTypes.string.isRequired,
  project: PropTypes.string.isRequired,
  range: PropTypes.string,
  value: PropTypes.array,
  onRemoveFilter: PropTypes.func.isRequired,
  graph: PropTypes.string.isRequired,
  defaultLang: PropTypes.string.isRequired
};

export default withRouter(withStyles(styles)(SearchFilter));